import { BBTreeviewNode } from '../../types'

export function toFilterSets<T>(arr: Array<T>, fn: (t: T) => BBTreeviewNode): Array<BBTreeviewNode> {
  return arr.map(fn)
}
